import { render, staticRenderFns } from "./BadgeBatch.vue?vue&type=template&id=5be1b682"
import script from "./BadgeBatch.vue?vue&type=script&lang=js"
export * from "./BadgeBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports